import { FF_CLEAR_FEATURE_FLAGS, FF_SET_FEATURE_FLAGS, FF_SET_FEATURE_FLAG_PAYLOAD } from './actionTypes';

/**
 * Set multiple feature flags at once
 *
 * @param {Object} flags - Object containing feature flag names as keys and boolean values
 * @returns {Object} Redux action object
 */
export const setFeatureFlags = (flags) => ({
  type: FF_SET_FEATURE_FLAGS,
  payload: { flags },
});

/**
 * Set a specific feature flag payload
 *
 * @param {string} flagName - The name of the feature flag
 * @param {*} payload - The payload data for the feature flag
 * @returns {Object} Redux action object
 */
export const setFeatureFlagPayload = (flagName, payload) => ({
  type: FF_SET_FEATURE_FLAG_PAYLOAD,
  payload: { flagName, payload },
});

/**
 * Clear all feature flags from the store
 *
 * @returns {Object} Redux action object
 */
export const clearFeatureFlags = () => ({
  type: FF_CLEAR_FEATURE_FLAGS,
});

/**
 * Initialize feature flags from PostHog
 *
 * @param {Object} flags - Object containing feature flag names as keys and boolean values
 * @param {Object} payloads - Object containing feature flag names as keys and their payloads
 * @returns {Function} Redux thunk function
 */
export const initializeFeatureFlags =
  (flags, payloads = {}) =>
  (dispatch) => {
    dispatch(setFeatureFlags(flags));

    Object.entries(payloads).forEach(([flagName, payload]) => {
      dispatch(setFeatureFlagPayload(flagName, payload));
    });
  };
